import { Pill } from "@financeable-com-au/financeable-ui";

const ApiLodgePill = () => {
  return <Pill accent={300}>API Lodge</Pill>;
};

export { ApiLodgePill };
